import React from 'react';
import { motion } from 'framer-motion';
import { DatabaseIcon, ShieldCheckIcon, ActivityIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function PlatformFeatures() {
  const pillars = [{
    icon: DatabaseIcon,
    title: 'Context',
    subtitle: 'How agents take action.',
    desc: 'MCPs into EHRs, payers, clearinghouses, labs, and pharmacy networks. Normalized, action-capable, agent-ready.'
  }, {
    icon: ShieldCheckIcon,
    title: 'Governance',
    subtitle: 'How agents earn trust.',
    desc: 'Agent identity, scoped permissions, and full audit trails built for HIPAA from day one.'
  }, {
    icon: ActivityIcon,
    title: 'Quality',
    subtitle: 'How agents stay reliable at scale.',
    desc: 'Evals, observability, and traces that surface hallucinations, regressions, and silent failures before patients or providers do.'
  }];
  return <section id="platform" className="py-24 bg-hubble-card/30 relative z-10 border-y border-hubble-border/50" data-id="element-149">
      <div className="max-w-7xl mx-auto px-6" data-id="element-150">
        <div className="text-center mb-16" data-id="element-151">
          <span className="text-hubble-signal text-[12px] md:text-[14px] font-body font-medium tracking-[3px] uppercase mb-4 block" data-id="element-152">
            PLATFORM
          </span>
          <h2 className="font-heading text-4xl md:text-5xl font-normal tracking-[-1px] text-hubble-paper mb-4" data-id="element-153">
            Three layers. One platform.
          </h2>
          <p className="font-body text-[16px] md:text-[18px] text-hubble-paper/70 max-w-2xl mx-auto leading-[1.6]" data-id="element-154">
            Everything a healthcare AI agent needs to reach production.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-155">
          {[{
          icon: DatabaseIcon,
          title: 'Context',
          subtitle: 'How agents take action.',
          desc: 'Access to EHRs, payers, clearinghouses, labs, and pharmacy networks. Normalized and action-ready, so agents do real clinical work.'
        }, {
          icon: ShieldCheckIcon,
          title: 'Governance',
          subtitle: 'How agents earn trust.',
          desc: 'Agent identity, scoped permissions, and full audit trails, built for HIPAA from day one.'
        }, {
          icon: ActivityIcon,
          title: 'Quality',
          subtitle: 'How agents stay reliable at scale.',
          desc: 'Evals, observability, and traces that surface hallucinations, regressions, and silent failures before patients or providers do.'
        }].map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-hubble-card border border-hubble-border rounded-2xl p-8 hover:border-hubble-signal/30 transition-colors group relative overflow-hidden" data-id="element-156">
              <div className="absolute inset-0 bg-gradient-to-br from-hubble-signal/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-157"></div>

              <div className="relative z-10" data-id="element-158">
                <div className="w-12 h-12 rounded-xl bg-hubble-signal/10 border border-hubble-signal/20 flex items-center justify-center mb-6" data-id="element-159">
                  <pillar.icon className="w-6 h-6 text-hubble-signal" data-id="element-160" />
                </div>
                <h3 className="font-heading text-2xl font-medium text-hubble-paper mb-1" data-id="element-161">
                  {pillar.title}
                </h3>
                <p className="font-body text-sm text-hubble-signal mb-4" data-id="element-162">
                  {pillar.subtitle}
                </p>
                <p className="font-body text-[16px] text-hubble-paper/70 leading-[1.6]" data-id="element-163">
                  {pillar.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="flex justify-center mt-12" data-id="element-164">
          <Button variant="primary" size="sm" onClick={() => window.open('https://calendly.com/prabha-hubble/30min?month=2026-04', '_blank')} data-id="element-165">
            Book a Demo
          </Button>
        </div>
      </div>
    </section>;
}